import React, { useEffect, useState, useContext } from "react";
import ContractOptions from "./ContractOptions";

// LIBS
import { DefaultTable } from "js-smart-table/dist/pagination";

// CONTEXT
import TableContext from "../../../../context/Table/TableContext";

// COMPONENTS
import { CustomTable } from "../../../../components/general/Table/CustomTable";

// HELPERS
import ConfigTable from "../../../../static/StaticTables/Contract";

// APIS
import { fetchDocuments } from "../../../../helpers/Apis/Documents";

import useDocuments from "../../../../customHooks/useDocuments";
import { CancelModal } from "../CancelModal";
import { BotonneraContainer } from "../../../Inicio/Modals/Styles";

export default function Contract({ rowInfo }) {
  // let TableContract;

  // const [rowInfo, setRowInfo] = useState(null);

  // const { refetch, setLengthData } = useContext(TableContext);

  // const { notifyDocumentsWithFiles, shortCutAssociateFiles, prepareExcelData } =
  //   useDocuments();

  // let TableQuotesConfig = {
  //   ...ConfigTable,
  //   cbSelection: () => setRowInfo(TableContract.infoRow),
  // };

  // useEffect(() => {
  //   async function initialLoad() {
  //     const { actualPage, documents, pages } = await fetchDocuments(
  //       1,
  //       "DESC",
  //       "idDocument"
  //     );

  //     TableQuotesConfig = {
  //       ...TableQuotesConfig,
  //       rows: documents,
  //       pages,
  //       actualPage,
  //       paginationFn: async function (
  //         page,
  //         order,
  //         columnOrdering,
  //         queryString
  //       ) {
  //         const documents = await fetchDocuments(
  //           page,
  //           order,
  //           columnOrdering,
  //           queryString
  //         );
  //         notifyDocumentsWithFiles(documents.documents);
  //         // shortCutAssociateFiles(documents.documents);
  //         prepareExcelData(documents.documents);
  //         return documents;
  //       },
  //     };

  //     TableContract = new DefaultTable(TableQuotesConfig);
  //     TableContract.printTable();
  //     TableContract.printPagination();
  //     setLengthData(documents.length);

  //     notifyDocumentsWithFiles(documents);
  //     // shortCutAssociateFiles(documents);
  //     prepareExcelData(documents);
  //   }

  //   initialLoad();
  // }, [refetch]);

  return (
    <>
      <CustomTable tableID="documents" paginationID="contractPagination" />
      {/* <CancelModal rowInfo={rowInfo} /> */}
    </>
    // <div>
    //   <BotonneraContainer className="container d-flex justify-content-start aling-items-start mb-2 px-0 w-100">
    //     {rowInfo === null ? null : <ContractOptions rowInfo={rowInfo} />}
    //   </BotonneraContainer>
    //   <CustomTable tableID="documents" paginationID="contractPagination" />
    //   <CancelModal rowInfo={rowInfo} />
    // </div>
  );
}
